module.exports = __webpack_public_path__ + "img/1.0bd5f9a5.png";